import React, { useState } from 'react';
import { useNavigate ,useLocation } from 'react-router-dom';
import { Box,styled } from '@mui/material';

const Hospital = styled(Box)({
    '.navbar':{
        alignItems:'center',
        justifyContent:'space-between',
        display:'flex',
        border:'1px solid #212121',
        flexDirection:'row',
        flexWrap:'wrap',
        padding:'0',
        paddingLeft:'20px',
        paddingRight:'20px',
        backgroundColor:'#5382c2',
        color:'white'
    },
    '.mainMenu':{
        marginTop:'5px',
        alignItems:'center',
        justifyContent:'center',
        display:'flex',
        flexDirection:'row',
        flexWrap:'wrap',
        padding:'10px',
        gap:'10px'
    },
    '.radio-inputs':{  
        position:'relative',
        display:'flex',
        borderRadius:'0.5rem',
        backgroundColor:'#EEE',
        boxSizing:'border-box',
        boxShadow:'0 0 0px 1px rgba(0,0,0,0.06)',
        padding: '0.25rem',
        width: '100px',
        fontSize: '14px',
    },
    '.radio-inputs .radio':{
        flex:'1 1 auto',
        textAlign:'center'
    },
    '.radio-inputs .radio input':{
        display:'none'
    },
    '.radio-inputs .radio .name':{
        display:'flex',
        cursor:'pointer',
        alignItems:'center',
        justifyContent:'center',
        borderRadius:'0.5rem',
        border:'none',
        padding:'.5rem 0',
        color: 'rgba(51,65,85,1)',
        transition: 'all .15s ease-in-out'
    },
    '.radio-inputs .radio input:checked + .name':{
        backgroundColor: '#fff',
        fontWeight:'600'
    },
    'button':{
        boxSizing:'border-box',
        border:'0',
        borderRadius:'20px',
        color:'#313131',
        padding:'0.7em 1em',
        background: '#fff',
        display: 'flex',
        transition:'0.2s background',
        fontWeight:'bold',
        gap:'2px'
    },
    'button .arrow-wrapper':{
        // border:'1px solid red',
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        marginTop:'6px'
    },
    'button .arrow':{
        marginTop:'1px',
        width:'10px',
        background:'#fff',
        height:'2px',
        position:'relative',
        transition:'0.2s'
    },
    'button .arrow::before':{
        content:'""',
        boxSizing:'border-box',
        position:'absolute',
        border:'solid #313131',
        borderWidth:'2px 0 0 2px',
        display:'inline-block',
        top:'-3px',
        left:'3px',
        transition:'0.2s',
        padding:'3px',
        transform:'rotate(-45deg)'
    },
    'button:hover':{
        backgroundColor:'#fff'
    },
    'button:hover .arrow':{
        background:'#313131'
    },
    'button:hover .arrow:before':{
        left:'0'
    }
})

const About = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get("token");
    const [active, setActive] = useState();

    const handleActive = (value) => {
        setActive(value);
    }

    return(
        <Hospital>
            <div className='navbar'>
                <p>Your Token: {token}</p>
                <button onClick={()=> navigate('/hospital')}>Back 
                    <div className='arrow-wrapper'>
                        <div className='arrow'></div>
                    </div>
                </button>
            </div>
            
        <div className='mainMenu'>
            <div className='radio-inputs'>
                <label onClick={() => handleActive('1')} className='radio'>
                    <input type='radio' name='radio'/>
                    <span className='name'>hospital1</span>
                </label>
            </div>
            <div className='radio-inputs'>
                <label onClick={() => handleActive('2')} className='radio'>
                    <input type='radio' name='radio' />
                    <span className='name'>hospital2</span>
                </label>
            </div>
            <div className='radio-inputs'>
                <label onClick={() => handleActive('3')} className='radio'>
                    <input type='radio' name='radio' />
                    <span className='name'>hospital3</span>
                </label>
            </div>
            <div className='radio-inputs'>
                <label onClick={() => handleActive('4')} className='radio'>
                    <input type='radio' name='radio' />
                    <span className='name'>hospital4</span>
                </label>
            </div>
            <div className='radio-inputs'>
                <label onClick={() => handleActive('5')} className='radio'>
                    <input type='radio' name='radio' />
                    <span className='name'>hospital5</span>
                </label>
            </div>
            <div className='radio-inputs'>
                <label onClick={() => handleActive('6')} className='radio'>
                    <input type='radio' name='radio' />
                    <span className='name'>hospital6</span>
                </label>
            </div>
            <div className='radio-inputs'>
                <label onClick={() => handleActive('7')} className='radio'>
                    <input type='radio' name='radio' />
                    <span className='name'>hospital7</span>
                </label>
            </div>
            <div className='radio-inputs'>
                <label onClick={() => handleActive('8')} className='radio'>
                    <input type='radio' name='radio' />
                    <span className='name'>hospital8</span>
                </label>
            </div>
            <div className='radio-inputs'>
                <label onClick={() => handleActive('9')} className='radio'>
                    <input type='radio' name='radio' />
                    <span className='name'>hospital9</span>
                </label>
            </div>
            <div className='radio-inputs'>
                <label onClick={() => handleActive('10')} className='radio'>
                    <input type='radio' name='radio' />
                    <span className='name'>hospital10</span>
                </label>
            </div>
        </div> 
          {/* <Box sx={{ width:'100%'}}>
                {LinkComponent.map((data) => (
                    <>
                    {data && (
                        <>
                        {active === data.value && (
                            <data.component/>
                        )}
                        </>
                    )}
                    </>
                ))}
          </Box> */}
        </Hospital>    
    )
}

export default About